import { render, staticRenderFns } from "./image-feed.vue?vue&type=template&id=2f1ade7d&scoped=true&"
import script from "./image-feed.vue?vue&type=script&lang=js&"
export * from "./image-feed.vue?vue&type=script&lang=js&"
import style0 from "./image-feed.vue?vue&type=style&index=0&id=2f1ade7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ade7d",
  null
  
)

export default component.exports